import PageProtected from "../../../../components/Page/PageProtected";
import SectionPharmaDrugs from "./Sections/SectionPharmaDrugs";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import SectionDrugSearch from "./Sections/SectionDrugSearch"
import SectionDisclaimer from "../../../../components/Disclaimer/SectionDisclaimer";
import DisclaimerCardpgx from "./Sections/DisclaimerCardpgx";
import { useTheme } from "@mui/material";


export default function DrugWelcome() {

     const theme = useTheme();
   
    return (
    <>
    
    <PageProtected
    
            headline="PHARMACOGENETICS - "
            specify="MEDICATION GUIDE"
            
            main={<>


    {theme.palette.mode === "light" ? (

     <SectionDashboard
      
      colorContainer="transparent"

      colorSection_1="grey.C300"
      Section_1={ <SectionDrugSearch />}

      colorSection_2="grey.C400"
      Section_2={<SectionPharmaDrugs />}

      colorSection_3 = "grey.C100"
      Section_3 = {<SectionDisclaimer disclaimer={<DisclaimerCardpgx /> } />}

    />

    ) :(
       
     <SectionDashboard
      
      colorContainer="transparent"

      colorSection_1="greydark.C600"
      Section_1={ <SectionDrugSearch />}

      colorSection_2="greydark.C800"
      Section_2={ <SectionPharmaDrugs />}

      colorSection_3="greydark.C800"
      Section_3={<SectionDisclaimer disclaimer={<DisclaimerCardpgx /> } />} 
    />
    )}

    </>}
    />
</>
)}